import { Injectable } from '@angular/core';
import { StoreConfig, Store, ID } from '@datorama/akita';

export interface DocumentsOwnerState {
  id?: ID;
  data:any
}

export function createInitialState(): DocumentsOwnerState {
  return {
    id: '',
    data: []
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({
  name: 'documentsOwner',
  resettable: true,
  cache: {
    ttl: 3600000
  }
})
export class DocumentsOwnerStore extends Store<DocumentsOwnerState> {
  constructor() {
    super(createInitialState());
  }
}
